module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/BE-535659bd709a5713a1e7642bdf7c3e26.png";